export default __webpack_public_path__ + "static/media/google-play.21c5a138.png";